import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postLogin
} from "../../../helpers/fakebackend_helper";

const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, history } }) {
  try {
    // Attempt to login and await response
    const response = yield call(postLogin, {
      email: user.email,
      password: user.password,
    });
    console.log(response)
    // Save token and role in localStorage
    localStorage.setItem("authUser", JSON.stringify({
      token: response?.token,
      role: response?.role,
      email: user.email,
      username: response?.username
    }));
    localStorage.setItem('userId', response?.id);

    // Dispatch successful login action
    yield put(loginSuccess(response));

    // Navigate to dashboard
    history('/dashboard');
  } catch (error) {
    // Check for error message from the backend response or use a default message
    const errorMessage = error?.response?.data?.error || "Login failed. Please try again.";

    // Clear any previously stored user data on error
    localStorage.removeItem("authUser");

    // Dispatch the error message to Redux for the modal to display
    yield put(apiError(errorMessage));
  }
}


function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(response));
    }
    history('/login');
  } catch (error) {
    yield put(apiError(error));
  }
}

function* socialLogin({ payload: { type, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(fireBaseBackend.socialLoginUser, type);
      if (response) {
        history("/dashboard");
      } else {
        history("/login");
      }
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    if(response)
    history("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
